import { useNote } from '@components/ArtBoard/Block/Note/useNote'
import type React from 'react'

import { clsJoin } from '@/utils'
import {
  CommentCounter,
  CommentWithContent,
  ContentIndicator,
  EmptyState,
} from './components'
import css from './styles.module.css'

interface Props {
  blockId: string
  completed: boolean
}

export const Note: React.FC<Props> = ({ blockId, completed }) => {
  const {
    disabled,
    commentsCount,
    themeBlueprint,
    hideComponent,
    light,
    hasImage,
    contentOnly,
    commentsOnly,
    contentWithComments,
    empty,
    onClick,
  } = useNote(blockId)

  const cn = clsJoin(
    css.note,
    'block_note',
    contentOnly && css.only_content,
    disabled && css.disabled,
    completed && css.completed,
    light && css.light
  )

  const noteItemCommonCn = clsJoin(
    css.note_item,
    themeBlueprint && css.blueprint,
    completed && css.completed,
    light && css.light,
    hasImage && css.has_image
  )

  if (hideComponent) {
    return null
  }

  return (
    <div className={cn} onClick={onClick}>
      {contentOnly && <ContentIndicator className={noteItemCommonCn} />}

      {commentsOnly && (
        <CommentCounter counter={commentsCount} className={noteItemCommonCn} />
      )}

      {contentWithComments && (
        <CommentWithContent
          counter={commentsCount}
          className={noteItemCommonCn}
        />
      )}

      {empty && <EmptyState className={noteItemCommonCn} />}
    </div>
  )
}
